"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchReceiptsGql = fetchReceiptsGql;
const tslib_1 = require("tslib");
const queries_js_1 = require("./queries.js");
const client_js_1 = tslib_1.__importDefault(require("./client.js"));
const maps_js_1 = require("../common/maps.js");
async function fetchReceiptsGql() {
    let receiptNodes = [];
    let hasNextPage = true;
    let cursor = null;
    //   let count = 0;
    while (hasNextPage) {
        const result = await client_js_1.default.query({
            query: queries_js_1.GET_RECEIPT_DATA,
            variables: {
                after: cursor,
                receiptType: maps_js_1.poolInfo["ALPHA"].receiptType,
                limit: 10,
            },
        });
        // Now destructure from the properly typed variable
        const data = result.data;
        if (!data)
            break;
        const { nodes, pageInfo } = data.objects;
        receiptNodes = receiptNodes.concat(nodes);
        hasNextPage = pageInfo.hasNextPage;
        cursor = pageInfo.endCursor;
        // console.log(count++);
    }
    const receiptsJson = receiptNodes.map((node) => {
        return node.asMoveObject.contents.json;
    });
    return receiptsJson;
}
//# sourceMappingURL=fetchReceipts.js.map